// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { Col, Row } from '@op/opds.opux';
import LinkToMainPage from '../../components/LinkToMainPage';
import DownloadPdfButton from './DownloadPdfButton';
import ManualSigningBackButton from './ManualSigningBackButton';

interface PdfState {
    isLoading: boolean;
    error: boolean;
}

interface ManualSigningFooterProps {
    setPdfState: React.Dispatch<React.SetStateAction<PdfState>>;
    width: number;
}

const ManualSigningFooter: React.FC<ManualSigningFooterProps> = ({ setPdfState, width }) => {
    const viewThreshold: number = 760;

    return (
        <>
            {width > viewThreshold ? (
                <Row middle="sm" className="navigation-btn opux-spacing-top-margin-double" data-testid="row-large">
                    <Col sm={1} className="opux-align-left" data-testid="col-back-button">
                        <ManualSigningBackButton />
                    </Col>
                    <Col sm={5} smOffset={6} data-testid="col-download-button">
                        <DownloadPdfButton setPdfState={setPdfState} />
                    </Col>
                </Row>
            ) : (
                <>
                    <div
                        className="opux-spacing-bottom-margin-double opux-align-center opux-spacing-top-margin-double"
                        data-testid="div-download-button"
                    >
                        <DownloadPdfButton setPdfState={setPdfState} />
                    </div>
                    <div className="opux-align-center" data-testid="div-back-button">
                        <ManualSigningBackButton />
                    </div>
                </>
            )}
            <LinkToMainPage />
        </>
    );
};

export default ManualSigningFooter;
